import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import UnlockIcon from '@wix/da-ds/pkg/Icons/24x24/Unlock';
import { CommissionStatusCodes, CommissionStatusType, } from '../../../types/commissions';
import CommissionConfirmation from '../../../CommissionEditPopup/CommissionConfirmation';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
export var CommissionStatusButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var _b = useState(false), showConfirmationPopup = _b[0], setShowConfirmationPopup = _b[1];
    if (!deviation.commission ||
        deviation.commission.status === CommissionStatusCodes.STATUS_DELETED) {
        return null;
    }
    var isActive = deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionBarItemWrapper, { tooltip: isActive
                ? t('actionbar.closeCommission')
                : t('actionbar.openCommission') },
            React.createElement(ActionBarEditButton, { onClick: function () { return setShowConfirmationPopup(true); } },
                React.createElement(ActionBarIcon, { icon: isActive ? UnlockIcon : LockIcon }))),
        showConfirmationPopup && (React.createElement(CommissionConfirmation, { isOpen: true, confirmationType: isActive ? 'disable' : 'enable', onCancel: function () { return setShowConfirmationPopup(false); }, onConfirm: function () {
                setShowConfirmationPopup(false);
                onClick({
                    deviation: deviation,
                    status: isActive
                        ? CommissionStatusType.DISABLED
                        : CommissionStatusType.ACTIVE,
                });
            } }))));
};
CommissionStatusButton.displayName = 'CommissionStatusButton';
export default CommissionStatusButton;
//# sourceMappingURL=CommissionStatusButton.js.map